import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  propertyTaxes?: number;
  purchasePrice?: number;
  propertyValue?: number;
  purchasePriceActive?: boolean;
}

export const calculatePropertyTaxesPercentage = (
  form: FormInstance,
  loanIndex: string | number,
  {
    propertyTaxes,
    purchasePrice,
    propertyValue,
    purchasePriceActive
  }: FieldValues = {}
): number => {
  const propertyTaxesValue = propertyTaxes ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'propertyTaxes', 'value'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  if (!price) return 0;

  const percentage = ((propertyTaxesValue * 12) / price) * 100;

  return parseFloat(formatAmount(percentage, { max: 3 }));
};
